import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import transform from "../../utils/jsonpath-object-transform";
import { mergeShoppingCart } from "../../utils/cart";
import {
  mappingGemsProductDetailSelection,
  mappingSitecoreToProductDetailHero,
  mappingGemsToProductDetailHero,
  mappingSitecoreToProductDetailHeroStore,
  mappingSitecoreToProductDetailSelection,
  mappingSitecoreToProductIconContent,
  mappingGemsToAddToCartBanner,
  mappingSitecoreToProductHeroMedia,
  mappingSitecoreToProductAccordion,
  mappingGemsProductDetailToCartItem,
  mappingGemsToOtherGear,
  mappingSitecoreToOtherGear
} from "../../mappings/ProductDetail";

import AddToCartBanner from "../../sections/add-to-cart-banner";
import GearShoppingPerks from "../../sections/gear-shopping-perks";
import ProductDetailHero from "../../sections/product-detail-hero";
import ProductDetailSelection from "../../sections/product-detail-selection";
import { getCategories } from "../../utils/measurements";
import IconContent from "../IconContent";
import HeroMedia from "../HeroMedia";
import Accordion from "../Accordion";
import api from "../../utils/api";
import ListContent from "../ListContent";
import { showCartAlert, addToCartItems, setSessionIdAction, setDynamicBreadcrumbList } from "../../redux/actions/actions";
import { selectShowCartAlert, selectSessionId } from "../../selectors/application";
import { getCart } from "../../services/cartService";
import queryGearDetail from "../../Graphql/queryGearDetail";
import queryBrand from "../../Graphql/queryBrand";
import queryGearLimited from "../../Graphql/queryGearLimited";
import useScrollListener from "../../hooks/useScrollListener.js";
import { canUseDOM, isBizNull, MathUtils } from "../../utils";
import { cartInfoSelector } from "../../selectors/gears-checkout";
import { Helmet } from "react-helmet";

const isSSR = canUseDOM() ? false : true;

const ProductDetail = ({ match, rendering, fields, showCartAlert, addToCartItems, setSessionId, sessionId, cartInfo, user, setDynamicBreadcrumbList }) => {
  const { addToCartButton = {}, addToCartButtonWithOptions = {}, shoppingPerks = {}, warningNeedToSelectVariant, soldOutMessage, productLink, brandLink, relatedGearHeading, relatedGearMaxCount } = fields,
    [productDetailSelectionGems, setProductDetailSelectionGems] = useState(null),
    [productDetailSelectionSitecore, setProductDetailSelectionSitecore] = useState(null),
    [productDetailHeroGems, setProductDetailHeroGems] = useState(null),
    [productDetailHeroSitecore, setProductDetailHeroSitecore] = useState(null),
    [heroStoreData, setHeroStoreData] = useState(null),
    [productIconContentData, setProductIconContentData] = useState(null),
    [productHeroMediaData, setProductHeroMediaData] = useState(null),
    [productAccordion, setProductAccordions] = useState(null),
    [productToCartAlertData, setProductToCartAlertData] = useState(null),
    [addToCartGemsData, setAddToCartBannerGemsData] = useState(),
    [relatedItemsGemsData, setRelatedItemsGemsData] = useState({}),
    [relatedItemsSitecoreData, setRelatedItemsSitecoreData] = useState({}),
    [isProductWithVariations, setIsProductWithVariations] = useState(false),
    [selectedSkuId, setSelectedSkuId] = useState(),
    [skuAttributeList, setSkuAttributeList] = useState(),
    [availableAttributes, setAvailableAttributes] = useState(),
    [selectedAttributes, setSelectedAttributes] = useState({}),
    [warningMessage, setWarningMeassage] = useState(),
    [productGA, setProductGA] = useState(),
    [isSoldOut, setIsSoldOut] = useState(),
    [priceInfo, setPriceInfo] = useState({
      priceFormatted: null,
      discountedPriceFormatted: null
      // add discounted price when function exist from gems do not use MSRP!
    }),
    [usableStockForSkuId, setUsableStockForSkuId] = useState(),
    [stockInfo, setStockInfo] = useState(),
    [productInfo, setProductInfo] = useState({}),
    [productBrandDetail, setProductBrandDetail] = useState(),
    [categoriesGems, setCategoriesGems] = useState(),
    [brandCategoryId, setBrandCategoryId] = useState(),
    [addToCartButtonIsDisabled, setAddToCartButtonIsDisabled] = useState(false),
    lang = match.params.lang,
    categories = match.params.cat1_id ? [match.params.cat1_id] : undefined,
    spuId = Number(match.params.spu_id),
    scBrandName = match.params.brand_name,
    scProductName = match.params.product_name;

  match.params.cat2_id && categories.length && categories.push(match.params.cat2_id);
  match.params.cat3_id && categories.length && categories.push(match.params.cat3_id);

  const { scrollDirection } = useScrollListener();

  const pdpSection = useRef();
  const addToCartButtonRef = useRef();
  const [isIntersecting, setIsIntersecting] = useState();

  const [structuredData, setStructuredData] = useState({
    "@context": "https://schema.org/",
    "@type": "Product",
    name: "",
    image: "",
    description: "",
    sku: "",
    brand: {
      "@type": "Brand",
      name: ""
    },
    offers: {
      "@type": "Offer",
      url: !isSSR ? window.location.href : "",
      priceCurrency: "",
      price: "",
      availability: "https://schema.org/InStock"
    }
  });

  const addButtonObserver = () => {
    try {
      if (addToCartButtonRef === null) {
        return;
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          setIsIntersecting(entry.isIntersecting);
        });
      });
      observer.observe(addToCartButtonRef.current);
      return () => {
        observer.unobserve(addToCartButtonRef.current);
      };
    } catch (error) {
      console.error(error);
    }
  };

  const executeScroll = ref => {
    ref.current && window.scrollTo(0, ref.current.offsetTop);
  };

  //Fetch product detail from Sitecore
  const fetchSitecoreProductDetail = () => {
    const gearDetailQuery = queryGearDetail({
      lang: lang,
      scBrandName: scBrandName,
      scProductName: scProductName
    });

    api.graphql(null, { query: gearDetailQuery }).then(res => {
      // Get related products
      fetchRelatedProductsGems();
      setRelatedItemsGemsData([]);

      // mappings
      /*** Product hero */
      const mappingResultDetailHero = transform(res, mappingSitecoreToProductDetailHero(res));
      mappingResultDetailHero && setProductDetailHeroSitecore(mappingResultDetailHero);

      /*** product detail?  */
      const mappingResultProductDeltailSelection = res ? transform(res, mappingSitecoreToProductDetailSelection(res)) : {};

      // I think these are mot the images we should use that why it is commented out in the object below./ Emma
      let images = res.data.gearDetail.children.filter(item => item.template.name === "Image").map(image => image.fields[0]);

      mappingResultProductDeltailSelection &&
        setProductDetailSelectionSitecore({
          ...mappingResultProductDeltailSelection
          //  images: images
        });

      /** Structured data for Google search */
      let country = lang.indexOf("-") > -1 ? lang.split("-")[1] : "en";
      let currency = "EUR";
      if (country === "se") {
        currency = "SEK";
      }
      let _structuredData = structuredData;
      _structuredData.description = mappingResultDetailHero.productDescription;
      _structuredData.offers.priceCurrency = currency;
      setStructuredData(_structuredData);

      /*** Accordion */
      const mappingResultAccordion = transform(res, mappingSitecoreToProductAccordion());
      mappingResultAccordion && setProductAccordions(mappingResultAccordion);

      /*** More items from hero (list content) */
      const mappingResultRelatedItems = transform(res, mappingSitecoreToOtherGear(relatedGearHeading?.value));

      mappingResultRelatedItems && setRelatedItemsSitecoreData(mappingResultRelatedItems);

      /*** hero media (video) */
      const heroMediaVideo = res.data.gearDetail.fields.find(x => x.name === "video");
      if (heroMediaVideo && heroMediaVideo.url) {
        const mappingResultHeroMedia = transform(res, mappingSitecoreToProductHeroMedia(res));
        mappingResultHeroMedia && setProductHeroMediaData(mappingResultHeroMedia);
      }

      /*** Icon content */
      const iconImage = res.data.gearDetail.fields.find(x => x.name === "imageIconContent");
      if (iconImage && iconImage.src) {
        const mappingResultIconContent = transform(res, mappingSitecoreToProductIconContent(res));
        mappingResultIconContent && setProductIconContentData(mappingResultIconContent);
      }
    });
  };

  //Fetch brand detail from Sitecore
  async function fetchSitecoreBrandDetail() {
    const brandQuery = queryBrand({ lang: lang, scBrandName: scBrandName });
    api.graphql(null, { query: brandQuery }).then(res => {
      /*** Hero store  */
      const mappingResultHeroStore = transform(res, mappingSitecoreToProductDetailHeroStore(res));
      mappingResultHeroStore && setHeroStoreData(mappingResultHeroStore);

      let categoryId = res.data.brand.fields.find(x => x.name === "categoryId").value;
      setBrandCategoryId(categoryId);

      /** Structured data for Google search */
      let _structuredData = structuredData;
      _structuredData.brand.name = mappingResultHeroStore.name;
      setStructuredData(_structuredData);
    });
  }

  async function fetchRelatedProductsGems() {
    let relatedProductsId = [];
    await api.product.recommend(null, { amount: relatedGearMaxCount?.value, spuId: spuId }).then(res => {
      if (res.obj) {
        relatedProductsId = res.obj;
      }
    });
    let spus = [];

    for (const id of relatedProductsId) {
      let productQuery = queryGearLimited({ lang: lang, spuId: id });
      await api.graphql(null, { query: productQuery }).then(res => {
        let product = res.data?.search?.results?.items[0];
        if (product) {
          var description = product.item.fields.find(obj => obj.name === "productDescription").value;
          let pathArray = product?.path.split("/");
          let path = pathArray[pathArray.length - 2];

          spus.push({ spuId: id, name: product?.name, brand: path, description });
        }
      });
    }

    api.product
      .list(null, {
        displayStart: 0,
        displayLength: spus.length,
        spuIds: spus.map(item => Number(item.spuId))
      })
      .then(res => {
        let _gearItems = [];
        let products_measurement = [];
        res.obj.data.forEach((product, index) => {
          let item = mappingGemsToOtherGear(
            {
              ...product
            },
            lang
          );
          var spu = spus.find(spu => spu.spuId.toString().toLowerCase() === product.spuId.toString().toLowerCase());

          item.fields.CTA[0].fields.link.value.linktype = "internal";
          item.fields.CTA[0].fields.link.value.href = `${productLink.value.href}/${product.spuId}--${spu?.brand}--${spu?.name}/`;
          item.fields.CTA[0].fields.link.value.text = productLink.value.text;
          item.fields.subtitle = {
            value: `<span class="type-body" style="margin-bottom: 10px;">${spu?.description}</span>`
          };

          /** Measurements */
          let categories = getCategories(product.categories);
          item.fields.CTA[0].fields.callback = () => {
            let dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: "productClick",
              products: [
                {
                  name: spu?.name,
                  id: product.spuId,
                  price: product?.minPrice,
                  brand: spu?.brand,
                  category: categories,
                  variant: "",
                  list: 1,
                  position: index
                }
              ]
            });
            window && window.scrollTo(0, 0);
            return true;
          };
          item.fields.spuId = product.spuId;
          _gearItems.push(item);

          let product_measurement = {
            name: spu?.name,
            id: product.spuId,
            price: product?.minPrice,
            brand: spu?.brand,
            category: categories,
            variant: ""
          };
          products_measurement.push(product_measurement);
        });

        setRelatedItemsGemsData(_gearItems);
        let dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "productImpression",
          products: products_measurement
        });
      });
  }

  //All possible product combination in stock with skuId
  async function getAvailableVariants(variants) {
    let finalVariants = [];
    let _variants = [];

    //get all available variation of the product
    for (const first of variants[0].options) {
      let variant = { [variants[0].label?.toLowerCase()]: first.label };
      if (variants[1]) {
        for (const second of variants[1].options) {
          _variants.push({
            ...variant,
            [variants[1].label?.toLowerCase()]: second.label
          });
        }
      } else {
        _variants.push(variant);
      }
    }

    //check for availability
    for (const variant of _variants) {
      await api.product
        .detail(null, {
          spuId: spuId,
          skuAttributeValueMap: variant
        })
        .then(res => {
          let skuId = (res.obj?.skuIdsList && res.obj?.skuIdsList[0]) || res.obj.skuId;
          api.product.sku
            .get({
              skuId: skuId
            })
            .then(res => {
              const mappingResultSkuIdPrice = {
                priceFormatted: res.obj.formattedPrice
              };

              finalVariants.push({
                ...variant,
                skuId: skuId,
                priceFormatted: mappingResultSkuIdPrice.priceFormatted,
                usableStock: res.obj.usableStock,
                soldOut: res.obj.usableStock === 0
              });
              setStockInfo(res);
            });
        });
    }

    setAvailableAttributes(finalVariants);
    productDetailSelectionGems && checkAvailabilityOfAttributes(finalVariants);
  }

  //remove attributes if they are out of stock
  const checkAvailabilityOfAttributes = availableAttributes => {
    let productDetailVariants = productDetailSelectionGems;

    Array.isArray(productDetailVariants) &&
      productDetailVariants.forEach(variant => {
        let availableProducts = [];
        variant.options.forEach(option => {
          let inStock = availableAttributes.find(obj => obj[variant.label] === option.label);
          inStock && availableProducts.push(option);
        });
        variant.options = availableProducts;
        //set existing selected value
        if (variant.label?.toLowerCase() === "color") {
          variant.selectedOption = variant.options[0];
          setSelectedAttributes({ color: variant.options[0].value });
        }
      });

    setProductDetailSelectionGems(productDetailVariants);
  };

  const fetchSkuId = (lang, skuId, cartInfo) => {
    let countOfSkuInCart = 0;
    if (cartInfo?.skuList) {
      let skuProduct = cartInfo.skuList.find(x => x.skuId === skuId);
      countOfSkuInCart = skuProduct?.skuCount || 0;
    }

    api.product.sku
      .get({
        skuId: skuId
      })
      .then(res => {
        /** Cart Alert selection    */
        const mappingResultToCartAlert = transform(
          res,
          mappingGemsProductDetailToCartItem({
            stockInfo: res,
            variationInfo: productInfo
          })
        );

        mappingResultToCartAlert && setProductToCartAlertData(mappingResultToCartAlert);

        const mappingResultSkuIdPrice = {
          price: res.obj.price,
          priceFormatted: MathUtils.priceFormat(res.obj.price, lang)
        };
        const mappingResultSkuImages = [
          ...res.obj.skuImagesList.map(item => ({
            name: "image",
            src: item.path
          }))
        ];
        setUsableStockForSkuId(res.obj.usableStock);

        mappingResultSkuImages?.length &&
          setProductDetailSelectionSitecore({
            ...productDetailSelectionSitecore,
            ...{ images: mappingResultSkuImages }
          });

        mappingResultSkuIdPrice && setPriceInfo({ ...priceInfo, ...mappingResultSkuIdPrice });
        // check if product is sold out
        if (res.obj.usableStock === 0 || res.obj.usableStock <= countOfSkuInCart || countOfSkuInCart >= 20) {
          setIsSoldOut(true);
        } else {
          setIsSoldOut(false);
        }
      });
  };

  const fetchSpuWithAttributesMap = (lang, spuId, attributesMap) => {
    api.product.detail(null, { spuId: spuId, skuAttributeValueMap: attributesMap }).then(res => {
      setSelectedSkuId((res.obj?.skuIdsList && res.obj?.skuIdsList[0]) || res.obj?.skuId);
      if (selectedSkuId === (res.obj?.skuIdsList && res.obj?.skuIdsList[0]) || res.obj?.skuId) {
        setAddToCartButtonIsDisabled(false);
      }
    });
  };

  const fetchGemsProductDetail = (lang, spuId) => {
    //Fetch product detail from GEMS
    api.product.detail(null, { spuId: spuId }).then(res => {
      setProductInfo(res);

      if (res.obj?.skuIdsList && res.obj?.skuIdsList.length > 1) {
        setIsProductWithVariations(true);
      }
      setSkuAttributeList(res.obj?.skuAttributeList);

      /*** Product hero */
      const mappingResultDetailHero = transform(res, mappingGemsToProductDetailHero(res));
      mappingResultDetailHero && setProductDetailHeroGems(mappingResultDetailHero);
      /*** Add to cart banner */
      const mappingResultAddToCartBanner = transform(res, mappingGemsToAddToCartBanner(res));
      mappingResultAddToCartBanner && setAddToCartBannerGemsData(mappingResultAddToCartBanner);

      /*** fix breadcrumb */
      let breadCrumbNode = {
        breadcrumbName: mappingResultAddToCartBanner.name,
        url: "",
        urlLevelText: "",
        childPages: []
      };
      setDynamicBreadcrumbList([breadCrumbNode]);

      /** Detail selection  */
      let mappingResultDetailSelection = transform(res, mappingGemsProductDetailSelection(res));
      mappingResultDetailSelection.variants.map(variant => {
        console.log("varainat", variant);
        if (variant.defaultLanguageLabel?.toLowerCase().trim() === "size") {
          variant.type = "radio";
          variant.selectedOption = undefined;
        }
        if (variant.defaultLanguageLabel?.toLowerCase().trim() === "color") {
          variant.selectedOption = variant.options[0];
          setSelectedAttributes({ color: variant.options[0].value });
        }
        return;
      });
      mappingResultDetailSelection && setProductDetailSelectionGems(mappingResultDetailSelection);

      setCategoriesGems(res.obj.categories);

      /** Measurements */
      let categories = getCategories(res.obj.categories);
      let product = {
        name: scProductName,
        id: res.obj.id,
        price: res.obj.lowestPrice,
        brand: scBrandName,
        category: categories,
        variant: ""
      };
      let dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "productDetail",
        products: [product]
      });
      setProductGA(product);

      /** Structured data for Google search */
      let defaultImage = res.obj.spuImagesList.find(image => image.imageType === "IMAGEDEFAULT");
      let _structuredData = structuredData;
      _structuredData.name = res.obj.productDescribe;
      _structuredData.sku = res.obj.id;
      _structuredData.image = [defaultImage?.path];
      _structuredData.offers.price = res.obj.lowestPrice;
      setStructuredData(_structuredData);
    });
  };

  const productVariantSelected = selectedVariant => {
    setAddToCartButtonIsDisabled(true);
    let _selectedAttributes = {};
    let keys = [];
    selectedVariant.forEach((attribute, index) => {
      if (attribute) {
        let key = `${skuAttributeList[index].lable}`;
        keys.push(key);
        _selectedAttributes[key] = attribute.value;
      }
    });
    setWarningMeassage(null);

    // set price for product with selected attributes
    if (availableAttributes) {
      if (keys.length > 1) {
        let inStock = availableAttributes.find(product => product[keys[0]] === _selectedAttributes[keys[0]] && product[keys[1]] === _selectedAttributes[keys[1]]);
        inStock &&
          setPriceInfo({
            price: inStock.priceFormatted,
            priceFormatted: MathUtils.priceFormat(inStock.priceFormatted, lang)
          });
      } else {
        let inStock = availableAttributes.find(product => product[keys[0]] === _selectedAttributes[keys[0]]);
        inStock &&
          setPriceInfo({
            price: inStock.priceFormatted,
            priceFormatted: MathUtils.priceFormat(inStock.priceFormatted, lang)
          });
      }
    }
    setSelectedAttributes(_selectedAttributes);
  };

  const addToCart = async () => {
    //Check that all attributes have a slection
    let allHasSelection = skuAttributeList?.length === Object.keys(selectedAttributes)?.length;

    if (!isSoldOut && (allHasSelection || !isProductWithVariations)) {
      /** Measurements */
      let product_measurement = productGA;
      product_measurement.variant = selectedSkuId;

      let dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: "addToCart",
        products: [product_measurement]
      });

      let detailsArray = [];
      Object.keys(selectedAttributes).forEach(key => {
        detailsArray.push({ title: key, value: selectedAttributes[key] });
      });

      let currentShoppingCart = await mergeShoppingCart(selectedSkuId, user?.userAccount, sessionId);
      if (!sessionId) {
        setSessionId(currentShoppingCart.obj.sessionId);
      }
      addToCartItems({
        spuId: spuId,
        skuId: selectedSkuId,
        skuAttributeValueMap: selectedAttributes
      });
      showCartAlert({
        ...productToCartAlertData,
        discountedPrice: priceInfo.discountedPrice || priceInfo.price,
        price: priceInfo.price,
        details: [...detailsArray, productBrandDetail],
        pageTriggerdForm: window.location.href
      });

      // check that item count is still in stock
      let countOfSkuInCart = 0;
      getCart(lang).then(res => {
        let skuProduct = res.obj.skuList?.find(x => x.skuId === selectedSkuId);
        countOfSkuInCart = skuProduct?.skuCount || 0;
        if (usableStockForSkuId === 0 || usableStockForSkuId <= countOfSkuInCart || countOfSkuInCart >= 20) {
          setIsSoldOut(true);
        } else {
          setIsSoldOut(false);
        }
      });
    } else if (!allHasSelection) {
      setWarningMeassage(warningNeedToSelectVariant.value);
    }
  };

  const fetchGemsPromotion = (skuId, price) => {
    api.user.promotion(null, { skuIds: [skuId] }).then(res => {
      const promotions = Array.isArray(res.obj) ? res.obj : [];
      let discountedPrice = price;
      promotions.forEach(element => {
        if (element.discountRate) discountedPrice -= (element.discountRate / 100) * price;
        if (element.subAmt) discountedPrice -= element.subAmt;
      });
      discountedPrice < price &&
        setPriceInfo({
          ...priceInfo,
          discountedPrice: discountedPrice,
          discountedPriceFormatted: MathUtils.priceFormat(discountedPrice, lang)
        });
      discountedPrice === price &&
        setPriceInfo({
          ...priceInfo,
          price: discountedPrice,
          discountedPrice: null,
          discountedPriceFormatted: null
        });
    });
  };

  useEffect(() => {
    if (productDetailSelectionGems?.variants && productDetailSelectionGems.variants[0] && productDetailSelectionGems.variants[0].options) {
      getAvailableVariants(productDetailSelectionGems.variants);
    }
  }, [productDetailSelectionGems]);

  useEffect(() => {
    //clear old states
    setIsProductWithVariations(false);
    setProductDetailSelectionGems(null);
    setProductDetailSelectionSitecore(null);
    setProductDetailHeroGems(null);
    setProductDetailHeroSitecore(null);
    setProductIconContentData(null);
    setProductHeroMediaData(null);
    setHeroStoreData(null);
  }, [spuId]);

  useEffect(() => {
    //fetch data if all old data is cleared
    if (productDetailHeroGems === null && productDetailHeroSitecore === null && productDetailHeroGems === null && productDetailHeroSitecore === null && productIconContentData === null && productHeroMediaData === null && heroStoreData === null) {
      fetchGemsProductDetail(lang, spuId);
      fetchSitecoreProductDetail(lang, spuId);
      fetchSitecoreBrandDetail().then();
    }
  }, [productDetailHeroGems, productDetailHeroSitecore, productDetailHeroGems, productDetailHeroSitecore, productIconContentData, productHeroMediaData, heroStoreData]);

  useEffect(() => {
    fetchSpuWithAttributesMap(lang, spuId, selectedAttributes);
  }, [spuId, selectedAttributes]);

  useEffect(() => {
    if (!isBizNull(selectedSkuId) && !isBizNull(productInfo) && !isBizNull(cartInfo)) {
      fetchSkuId(lang, selectedSkuId, cartInfo);
    } else {
      setAddToCartButtonIsDisabled(false);
    }
  }, [selectedSkuId, cartInfo, productInfo]);

  useEffect(() => {
    selectedSkuId && priceInfo.price && fetchGemsPromotion(selectedSkuId, priceInfo.price);
  }, [priceInfo.price, priceInfo.discountedPrice, selectedSkuId]);

  useEffect(() => {
    if (brandCategoryId && categoriesGems) {
      // brand detial row for cart
      let brandCategoryItem = categoriesGems.find(x => x.categoryId.toString() === brandCategoryId);
      let _productBrandDetail = {
        title: categoriesGems.find(x => x.categoryId === brandCategoryItem?.parentId)?.categoryName,
        value: brandCategoryItem?.categoryName
      };
      setProductBrandDetail(_productBrandDetail);
    }
  }, [brandCategoryId, categoriesGems]);

  useEffect(() => {
    setAddToCartButtonIsDisabled(false);
  }, [productToCartAlertData]);

  useEffect(() => {
    return function cleanup() {
      setDynamicBreadcrumbList(null);
    };
  }, []);
  return (
    <section datasourceid={rendering.dataSource} style={{ position: "relative" }}>
      {structuredData.name && structuredData.description && structuredData.brand.name && structuredData.offers.price && (
        <Helmet>
          <script className="structured-data-list" type="application/ld+json">
            {JSON.stringify(structuredData)}
          </script>
        </Helmet>
      )}
      {/*  Add more components for the prduct detail page */}
      <ProductDetailHero
        {...{
          ...productDetailHeroGems,
          ...productDetailHeroSitecore,
          ...priceInfo,
          productBrand: heroStoreData && heroStoreData.name
        }}
      />
      <GearShoppingPerks perks={shoppingPerks} />

      {!isProductWithVariations && (
        <AddToCartBanner
          button={{
            ...addToCartButton.fields,
            buttonText: addToCartButton.fields.buttonText.value,
            isDisabled: addToCartButtonIsDisabled || isSoldOut,
            callback: () => {
              addToCart();
            }
          }}
          hide={isIntersecting}
          headerIsHidden={scrollDirection === "down"}
          product={{
            ...addToCartGemsData,
            price: priceInfo.priceFormatted
          }}
        />
      )}
      {isProductWithVariations && (
        <AddToCartBanner
          button={{
            ...addToCartButtonWithOptions.fields,
            buttonText: addToCartButtonWithOptions.fields.buttonText.value,
            callback: () => {
              executeScroll(pdpSection);
            }
          }}
          headerIsHidden={scrollDirection === "down"}
          hide={isIntersecting}
          product={{
            ...addToCartGemsData,
            price: priceInfo.priceFormatted
          }}
        />
      )}

      {productIconContentData && productIconContentData.fields && (productIconContentData.fields.headingBody.value || productIconContentData.fields.body || productIconContentData.fields.image) && <IconContent {...productIconContentData} />}

      {productHeroMediaData && productHeroMediaData.fields && (productHeroMediaData.fields.headingBody || productHeroMediaData.fields.image.value.src) && <HeroMedia {...productHeroMediaData} />}

      <div>
        {availableAttributes && (
          <div ref={pdpSection}>
            <ProductDetailSelection
              ref={addToCartButtonRef}
              {...{
                ...productDetailSelectionGems,
                ...productDetailSelectionSitecore,
                ...priceInfo,
                overlineText: heroStoreData && heroStoreData.name,
                isProductWithVariations,
                isSoldOut,
                selectedOptionChanged: selectedVariant => productVariantSelected(selectedVariant),
                selectedOptionId: selectedSkuId,
                availableVariants: availableAttributes,
                warningMessage,
                soldOutMessage: soldOutMessage?.value,
                cta: {
                  //maybe not have the same sitecore config for alladd to cart button (before I have added the banner buttons so I reused it here)
                  ...addToCartButton.fields,
                  colorSceme: { fields: { phrase: { value: "green" } } },
                  buttonText: addToCartButton.fields.buttonText.value,
                  isDisabled: addToCartButtonIsDisabled,
                  callback: () => {
                    addToCart();
                  }
                },
                onRefLoaded: () => addButtonObserver()
              }}
            />
          </div>
        )}
      </div>
      <Accordion {...productAccordion} />

      {heroStoreData && heroStoreData.name && (
        <HeroMedia
          {...{
            ...heroStoreData,
            fields: {
              ...heroStoreData.fields,
              CTA: [
                {
                  fields: {
                    ctatype: {
                      fields: {
                        key: { value: "primary-button" },
                        phrase: { value: "primary-button" }
                      }
                    },
                    colorScheme: {
                      fields: { phrase: { value: "outline-white" } }
                    },
                    link: {
                      value: {
                        href: `${brandLink?.value?.href}/--${scBrandName}`,
                        linktype: "internal",
                        text: heroStoreData && heroStoreData.buttonText
                      }
                    },
                    iconName: {
                      value: {
                        alt: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"> <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z" /></svg>'
                      }
                    }
                  }
                }
              ]
            }
          }}
        />
      )}
      {relatedItemsGemsData && relatedItemsGemsData.length > 0 && relatedItemsSitecoreData.fields && relatedItemsSitecoreData.fields.headingBody && (
        <ListContent
          {...{
            ...relatedItemsSitecoreData,
            fields: {
              ...relatedItemsSitecoreData.fields,
              items: relatedItemsGemsData ? relatedItemsGemsData : []
            }
          }}
        />
      )}
    </section>
  );
};

ProductDetail.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    addToCartButton: PropTypes.object,
    shoppingPerks: PropTypes.array
  })
};
const mapStateToProps = state => ({
  isCartAlertVisible: selectShowCartAlert(state),
  sessionId: selectSessionId(state),
  cartInfo: cartInfoSelector(state)
});
const mapDispatchToProps = dispatch => ({
  addToCartItems: spuObj => dispatch(addToCartItems(spuObj)),
  showCartAlert: productToCartAlertData => dispatch(showCartAlert(productToCartAlertData)),
  setSessionId: sessionId => dispatch(setSessionIdAction(sessionId)),
  setDynamicBreadcrumbList: breadcrumbList => dispatch(setDynamicBreadcrumbList(breadcrumbList)),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetail);
